/*
* Salla Search Component: Site search modal.
* You can use these classes to target the elements in the component.
*/

.s-search {
  &-inline{
    
  }
  &-container {
    &-open {

    }
  }
  &-input {

  }
  &-icon {

  }
  &-spinner {

  }
  &-spinner-loader {

  }
  &-results {

  }
  &-no-results{

  }
  &-container-open{
    
  }
  &-product {
    &-image-container {

    }
    &-image {
      
    }
    &-details {

    }
    &-title {

    }
    &-price {

    }
  }
}
